import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Youtube(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 23"
  }, props), React.createElement("path", {
    d: "M13.126 15.742l-.002-9.188 8.94 4.61-8.938 4.578zm19.626-10.78s-.323-2.254-1.315-3.246C30.179.414 28.769.407 28.122.33 23.492 0 16.548 0 16.548 0h-.014S9.59 0 4.96.33c-.646.077-2.056.084-3.314 1.386C.654 2.708.33 4.962.33 4.962S0 7.608 0 10.254v2.481c0 2.647.33 5.293.33 5.293s.324 2.253 1.316 3.246c1.258 1.302 2.911 1.261 3.647 1.397 2.647.251 11.248.329 11.248.329s6.952-.01 11.581-.341c.647-.076 2.057-.083 3.315-1.385.992-.993 1.315-3.246 1.315-3.246s.33-2.646.33-5.293v-2.48c0-2.647-.33-5.293-.33-5.293z"
  }));
}

export { Youtube };
//# sourceMappingURL=Youtube.js.map